module.exports = __webpack_public_path__ + "08_2x.jpg?1264818c8d3aef7a00010f3179cedf39";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/08_2x.jpg
// module id = 82
// module chunks = 0